import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'pn-system-setting',
    standalone: true,
    imports: [RouterOutlet],
    template: `
        <router-outlet />
    `,
    styles: ``,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SystemSettingComponent {}
